export const RoutesEnabled = {
  umrah: false,
}
